import { render, staticRenderFns } from "./ResultsPerBuyer.vue?vue&type=template&id=b1f227ba&"
import script from "./ResultsPerBuyer.vue?vue&type=script&lang=js&"
export * from "./ResultsPerBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports